import { useCallback, useMemo } from 'react'

import { GridOptions } from 'ag-grid-community'
import cx from 'classnames'
import { includes } from 'lodash'

import {
  colDefByDataType,
  colDefById,
  defaultColDef,
} from '@ors/config/Table/columnsDef'
import { NON_EDITABLE_ROWS } from '@ors/config/Table/columnsDef/settings'

function getCellEditor(type: string) {
  switch (type) {
    case 'date':
      return 'agAdmDateCellEditor'
    case 'float':
      return 'agAdmNumberCellEditor'
    case 'number':
      return 'agAdmNumberCellEditor'
    case 'text':
      return 'agAdmTextCellEditor'
    default:
      return 'agAdmTextCellEditor'
  }
}

function useGridOptions(props: { adm_columns: any }) {
  const { adm_columns } = props

  const mapAdmColumn = useCallback((column: any) => {
    return {
      id: column.id,
      category: 'adm',
      dataType: column.type,
      // flex: 1,
      headerName: column.display_name,
      // initialWidth: defaultColDef.minWidth,
      ...(colDefByDataType[column.type] || {}),
      ...(column.children.length
        ? {
            children: column.children.map(mapAdmColumn),
            headerGroupComponent: 'agColumnHeaderGroup',
            marryChildren: true,
          }
        : {
            cellEditor: getCellEditor(column.type),
            field: `adm_${column.id}`,
          }),
      ...(colDefById[column.full_name] || {}),
      cellClass: 'ag-text-center',
      headerClass: 'ag-text-center',
    }
  }, [])

  const gridOptions: GridOptions = useMemo(
    () => ({
      columnDefs: [
        {
          cellClass: 'bg-mui-box-background',
          cellRendererParams: (props: any) => ({
            className: cx({
              'font-bold':
                props.data.level < 2 &&
                includes(['title', 'subtitle'], props.data.type),
            }),
          }),
          field: 'text',
          flex: 2,
          headerClass: 'ag-text-left',
          headerGroupComponent: 'agColumnHeaderGroup',
          headerName: 'Description',
          ...colDefById['adm_c_description'],
        },
        ...(adm_columns.length > 0 ? adm_columns.map(mapAdmColumn) : []),
      ],
      defaultColDef: {
        autoHeight: true,
        cellClass: 'ag-text-left',
        editable: (props) => !includes(NON_EDITABLE_ROWS, props.data.rowType),
        headerClass: 'ag-text-center',
        minWidth: defaultColDef.minWidth,
        resizable: true,
        wrapText: true,
      },
    }),
    // eslint-disable-next-line
    [adm_columns],
  )

  return gridOptions
}

export default useGridOptions
